module.exports = __webpack_public_path__ + "img/result-empty.088ade73.png";